import type { ServiceCode } from '@common/enums/serviceCode';
import { getServiceLabel } from '@common/customControls/getServiceLabel';

export function getTitle(serviceCode: ServiceCode, serviceName: string, title?: string | null) {
    const serviceLabel = getServiceLabel(serviceCode, 'request', serviceName);

    if (title) {
        return `${serviceLabel} - ${title}`;
    } else {
        return serviceLabel;
    }
}
